import {Modal} from 'bootstrap';

const modals = document.querySelectorAll('.modal')
const modalCallback = new Modal(document.querySelector('#callback'));
const modalPayment = new Modal(document.querySelector('#payment'));
const modalCallbackCourse = new Modal(document.querySelector('#callbackCourse'));
const modalCallbackOk = new Modal(document.querySelector('#callbackOk'));
const modalCallbackOk2 = new Modal(document.querySelector('#callbackOk2'));
const modalCart = new Modal(document.querySelector('#cart'));

modals.forEach(function(e) {
    e.addEventListener('shown.bs.modal', function () {
		if (this.querySelector('[autofocus]')){
			this.querySelector('[autofocus]').focus();
		}
	})
});

window.modalOpen = function(){
	modalCallback.show()
}

window.modalHide = function(){
	modalCallback.hide()
}

window.modalOpenPayment = function() {
	modalPayment.show()
}

window.modalHidePayment = function() {
	modalPayment.hide()
}

window.modalOpenCourse = function() {
	modalCallbackCourse.show()
}

window.modalHideCourse = function() {
	modalCallbackCourse.hide()
}

window.modalOpenOk = function() {
	modalCallbackOk.show()
}

window.modalHideOk = function() {
	modalCallbackOk.hide()
}

window.modalOpenOk2 = function() {
	modalCallbackOk2.show()
}

window.modalHideOk2 = function() {
	modalCallbackOk2.hide()
}

window.modalOpenCart = function(){
	modalCart.show()
}

window.modalHideCart = function(){
	modalCart.hide()
}


// window.modalOpen()
// window.modalOpenCourse()
// window.modalOpenOk()
// window.modalOpenOk2()
// window.modalHide()
// window.modalHideCourse()
// window.modalHideOk()
// window.modalHideOk2()
// window.modalOpenCart()
// window.modalHideCart()

document.addEventListener('DOMContentLoaded', function(){

    window.modal = {
        list: document.querySelectorAll('.modal'),
    }
    
    for (let index = 0; index < window.modal.list.length; index++) {
        const item = window.modal.list[index];
        const id = item.getAttribute('id')
        const itemModal = new Modal(item);

        window.modal[id] = itemModal;
    }
    
    window.modal.list.forEach(function(e) {
        e.addEventListener('shown.bs.modal', function () {
    		if (this.querySelector('[autofocus]')){
    			this.querySelector('[autofocus]').focus();
    		}
    	})
    });

    // window.modal.callback.show()
    // window.modal.payment.show()
    // window.modal.callbackCourse.show()
    // window.modal.callbackOk.show()
    // window.modal.callbackOk2.show()
    // window.modal.cart.show()
})
